import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-137fc817"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Welcome to Patient Profile Manegement"),
  /*#__PURE__*/_createElementVNode("p", null, "Please login or sign up to continue.")
], -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = {
  key: 0,
  type: "submit",
  class: "btn"
}
const _hoisted_5 = {
  key: 1,
  type: "submit",
  class: "btn",
  disabled: ""
}
const _hoisted_6 = { class: "message" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Not registered yet? ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Sign Up")
const _hoisted_9 = {
  key: 0,
  type: "submit",
  class: "btn"
}
const _hoisted_10 = {
  key: 1,
  type: "submit",
  class: "btn",
  disabled: ""
}
const _hoisted_11 = { class: "message" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Go Back to ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Login")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
          class: "login-form"
        }, [
          (!_ctx.isLogin)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                type: "text",
                name: "name",
                placeholder: "Name"
              }, null, 512)), [
                [_vModelText, _ctx.name]
              ])
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
            type: "text",
            name: "email",
            placeholder: "Email"
          }, null, 512), [
            [_vModelText, _ctx.email]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
            type: "password",
            name: "password",
            placeholder: "Password"
          }, null, 512), [
            [_vModelText, _ctx.password]
          ]),
          (_ctx.isLogin)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_4, "Login"))
                  : (_openBlock(), _createElementBlock("button", _hoisted_5, "Logging in...")),
                _createElementVNode("p", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_router_link, { to: "/signup" }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_9, "Sign up"))
                  : (_openBlock(), _createElementBlock("button", _hoisted_10, "Signing up....")),
                _createElementVNode("p", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ])
              ], 64))
        ], 32)
      ])
    ])
  ], 64))
}